import { render } from "./company-panel--supporter.vue?vue&type=template&id=a8876da4&scoped=true&ts=true"
import script from "./company-panel--supporter.vue?vue&type=script&lang=ts"
export * from "./company-panel--supporter.vue?vue&type=script&lang=ts"

import "./company-panel--supporter.vue?vue&type=style&index=0&id=a8876da4&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8876da4"]])

export default __exports__